import * as yup from 'yup';
import moment from 'moment';

export const signUpSchema = {
  fname: yup
    .string()
    .trim()
    .matches(/^[A-Za-z ]+$/, 'Please enter valid first name')
    .required('Please fill this field'),
  lname: yup
    .string()
    .trim()
    .matches(/^[A-Za-z ]+$/, 'Please enter valid last name')
    .required('Please fill this field'),
  email: yup
    .string()
    .email('Please enter valid email')
    .required('Please fill this field'),
  emailAgain: yup
    .string()
    .email('Please enter valid email')
    .oneOf([yup.ref('email'), null], "Emails don't match")
    .required('Please fill this field'),
  phone: yup
    .string()
    .min(11, 'Please enter valid phone number')
    // .matches(PHONE_NO_REGEX, 'Please enter valid phone number')
    .required(),
  dob: yup
    .string()
    .required('Please fill this field')
    .test('dob', 'Please enter valid DOB', value => {
      return moment(value).format('YYYY').length === 4;
    })
    .test('dob', 'Minimum age should be 18', value => {
      return moment().diff(moment(value), 'years') >= 18;
    })
    .nullable(),
  gender: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  education: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  hand: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  residence: yup.string().required('Please make a selection'),
  address: yup
    .string()
    .trim()
    .required('Please fill this field'),
  address2: yup.string().trim(),
  city: yup
    .string()
    .trim()
    .matches(/^[A-Za-z ]+$/, 'Please enter valid city')
    .required('Please fill this field'),
  state: yup.string().required('Please make a selection'),
  zip: yup
    .string()
    .min(5, 'Please enter minimum length of 5')
    .max(5, 'Please enter maximum length of 5')
    .matches(/^[0-9]+$/, 'Invalid zip code')
    .required(),
  language: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  aboutUs: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  race: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  ethnicity: yup
    .string()
    .required('Please make a selection')
    .nullable(),
  privacy: yup.bool().oneOf([true], 'Please accept privacy policy'),
  terms: yup.bool().oneOf([true], 'Please accept terms of service')
};

export const appointmentPaymentSchema = {
  name: yup
    .string()
    .trim()
    .required('Please fill this field'),
  cardNumber: yup
    .string()
    .trim()
    .matches(/^[0-9]+$/, 'Invalid Card number')
    .min(16, 'Please enter 16 digit number')
    .max(16, 'Please enter 16 digit number')
    .required('Please fill this field'),
  expDate: yup
    .string()
    .trim()
    .required('Please fill this field')
    .test(
      'test-expDate', // this is used internally by yup
      'Invalid Expiry date', //validation message
      value => {
        if (!value) return false;
        const [month, year] = value?.split('/');
        const today = moment();
        const expiryMonth =
          Number(month) !== 0 ? Number(month) - 1 : Number(month);
        const expiryYear = Number(year);
        const expiryDate = moment().set({
          year: expiryYear,
          month: expiryMonth
        });
        return moment(expiryDate).isSameOrAfter(today, 'day');
      }
    ),
  cvv: yup
    .string()
    .trim()
    .min(3, 'Please enter valid cvv')
    .max(4, 'Please enter valid cvv')
    .required('Please fill this field'),
  address: yup
    .string()
    .trim()
    .required('Please fill this field'),
  address2: yup.string().trim(),
  city: yup
    .string()
    .trim()
    .matches(/^[A-Za-z ]+$/, 'Please enter valid city')
    .required('Please fill this field'),
  state: yup.string().required('Please fill this field'),
  zip: yup
    .string()
    .trim()
    .matches(/^[0-9]+$/, 'Invalid Zipcode')
    .min(5, 'Please enter minimum length of 5')
    .max(5, 'Please enter maximum length of 5')
    .required()
};
